import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const updateDeliveryChallan = createAsyncThunk(
    "/prosafe/update-delivery-challan",
    async ({ id, payload }) => {

        try {
            const myurl = `${V_URL}/prosafe/update-delivery-challan/${id}`;
            const response = await axios({
                method: "put",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const updateDeliveryChallanSlice = createSlice({
    name: "updateDeliveryChallan",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateDeliveryChallan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDeliveryChallan.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(updateDeliveryChallan.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default updateDeliveryChallanSlice.reducer;
